export default {
  INCOMING_PAYMENT: 'incoming_payment',
  ACCOUNTING_FOR_CLASSES: 'accounting_for_classes',
  ACCOUNTING_FOR_LATE_CANCELLATION: 'accounting_for_late_cancellation',
  PAYMENT_FOR_CANCELLED_CLASSES_TO_RETURN: 'payment_for_cancelled_classes_to_return',
  INCOMING_PAYMENT_FOR_CLASSES: 'incoming_payment_for_classes',
  CORRECTION: 'correction',
  RETURN: 'return',
}
